<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>
    <navbar>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span
          class="font-weight-light"
        >{{device.device_name || device.device_token}} </span>
        <span
          class="font-weight-medium"
        > CLOUD DETAILS</span>
      </v-toolbar-title>
      <!--m-menu icon="mdi-content-save" label="File">
            <m-item icon="mdi-open-in-app" @click="onMenuFileOpen">Load Local File</m-item>
            <m-item icon="mdi-content-save">Download to Local File</m-item>
            <m-item icon="mdi-close">Close</m-item>
      </m-menu-->
      <!--m-menu v-if="loaded" icon="mdi-clock-outline" label="View Period">
            <m-item icon="mdi-timer" @click="()=>setPeriod(4)">4 Hours</m-item>
            <m-item icon="mdi-camera-timer" @click="()=>setPeriod(6)">6 Hours</m-item>
            <m-item icon="mdi-av-timer" @click="()=>setPeriod(8)">8 Hours</m-item>
            <m-item icon="mdi-clock-outline" @click="()=>setPeriod(12)">12 Hours</m-item>
            <m-item icon="mdi-calendar-clock" @click="()=>setPeriod(24)">1 Day</m-item>
            <m-item icon="mdi-timetable" @click="()=>setPeriod(24*7)">1 Week</m-item>
      </m-menu-->
      <v-spacer></v-spacer>

      <m-menubutton
        icon="mdi-database-edit"
        @click="showForm = true"
      >Edit Details</m-menubutton>
      <!--m-menu v-if="loaded" icon="mdi-table-settings" label="Table View">
        <m-item icon="mdi-table-column-remove" @click="onMenuTableHide">Hide Table</m-item>
        <m-item icon="mdi-table-large" @click="onMenuTableAll">All Readings</m-item>
        <m-item icon="mdi-chart-timeline-variant" @click="onMenuTableMaxMin">Daily Max/Min</m-item>
      </m-menu-->
      <v-spacer></v-spacer>
    </navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid>
        <v-expand-transition>

        <div v-show="showForm" style = "height:284px;">
        <v-card class="mt-10" v-show="showForm" height="284">
          <v-card-title class="primary text-center pa-4 secondary--text text--darken-3">
            <v-row justify="center">
              <span class="text-uppercase text-center font-weight-light">
                <span class="font-weight-medium">Device Details</span>
              </span>
            </v-row>
          </v-card-title>
          <v-card-text class="mb-2 mt-4 text-center" v-if="!showSuccessMessage">
            <p>Modify the cloud registered details of your {{productName}}.</p>
          </v-card-text>
          <v-card-actions>
            <v-row align="center" justify="center" v-show="!showSuccessMessage">
              <m-form
                v-slot="{model}"
                :query="apiEndpoints.updateDevice"
                :params="[$route.params.id]"
                :rules="validationRules"
                :modelSrc="device"
                @success="onFormSuccess"
                @success-complete="onFormSuccessComplete"
                @cancel="onFormCancel"
                lazy-validation
              >
                <v-row align="center" justify="center">
                  <m-textinput :model="model" name="device_name" label="Device Name" required></m-textinput>
                </v-row>
                <v-row class="mt-2">
                  <m-submit label="Update" :model="model"></m-submit>
                  <v-btn text color="primary" class="mb-3" @click="model.onFormCancel">Cancel</v-btn>
                </v-row>
              </m-form>
            </v-row>
            <v-row v-show="showSuccessMessage">
              <v-col class="text-center text-uppercase">
                <h2> <v-icon color="primary">mdi-check-circle</v-icon> Details Updated!</h2>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        </div>
            </v-expand-transition>
        <v-row>
          <v-col>
            <h2
              class="text-center text-uppercase"
            >Log files for "{{device.device_name || device.device_token}}"</h2>
          </v-col>
        </v-row>
        <log-file-list></log-file-list>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiRequest from "../mixins/api-request";
import apiEndpoints from "../mixins/api-endpoints";

export default {
  mixins: [apiRequest, apiEndpoints],
  data() {
    return {
      productName: process.env.MIX_PRODNAME,
      device: {
        device_name: "",
        device_token: "",
        files: []
      },
      validationRules: {
        device_name: model => [
          v => !!v || "Device name is required",
          v =>
            (v && v.length >= 3) || "Device name must be at least 3 characters"
        ]
      },
      showForm: false,
      showSuccessMessage:false,
    };
  },
  async mounted() {
    this.loadDeviceDetails();
  },
  methods: {
    processDeviceDetails(bodyData){
        this.device = bodyData;
        this.device.last_contact = new Date(this.device.last_contact * 1000);

    },
    loadDeviceDetails() {
      var devicePromise;
      devicePromise = this.apiRequest(
        this.apiEndpoints.devices,
        this.$route.params.id
      );
      devicePromise.then(r => {
        if (this.checkStatus(r, "Error loading device details from server.")){
          this.processDeviceDetails(r.body.data);
          this.showForm = ! this.device.device_name;
        }
      });
    },
    onFormSuccess(body) {
      this.processDeviceDetails(body.data);
      this.showSuccessMessage = true;
    },
    onFormSuccessComplete(body){
        this.showSuccessMessage = false;
        this.showForm = false;
    },
    onFormCancel() {
      this.showForm = false;
    },
  },
  computed: {}
};
</script>
